<template>



  <div class="header-box">


    <div class="header-box-top">

          <div class="hbt-item">

            <div class="icon">
              <el-icon v-if="show" @click="change"></el-icon>
              <el-icon v-else @click="change"></el-icon>
            </div>
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{current.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>

          </div>
          

          <div class="hbt-item" style="margin-left: 82%; line-height: 50px; padding-top: 5px; ">
            <div>
              <el-icon :size="size" :color="color">
                <BellFilled />
              </el-icon>
              <span class="payAudio"  @click="playAudio">{{ audioText }}</span>
              <audio ref="audioElement" :src="getMp3Url()"></audio>
            </div>
          </div>



          <!--头像-->
          <div class="hbt-item" style="margin-left: 20px;">

              <el-avatar :size="30" :src="circleUrl" style="margin-top: 15px;" />


              <el-dropdown>
                <span class="el-dropdown-link" link style="padding-top: 23px;">
                  &nbsp;&nbsp;设置
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <!-- <el-dropdown-item>设置账号</el-dropdown-item>
                    <el-dropdown-item>更改头像</el-dropdown-item> -->
                    <el-dropdown-item @click="goto('/password')">修改密码</el-dropdown-item>
                    <el-dropdown-item @click="exit">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>

              

          </div>


    </div>








    <!--面包屑-->
    <div class="tags-view">
      <TagsView />
    </div>


  </div>


  

</template>
 
<script setup>
	import { ref, reactive, toRefs, computed } from 'vue'
	//import { layoutStore } from '@/store/layout.js'
	import { ArrowDown } from '@element-plus/icons-vue'
	import { useRouter } from 'vue-router'
	import { outLogin } from "@/api/login";
	import { removeToken } from "@/utils/index";
	import TagsView from '@/components/TagsView/TagsView.vue';

	const router = useRouter();
	const current = computed(() => {
		return router.currentRoute.value
	})
	//console.log(router.currentRoute.value)
	//const store = layoutStore();
	const show = ref(true)
	const change = function () {
		show.value = !show.value;
		//store.changeisCollapse();
	}
	const state = reactive({
		circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
	})
	const { circleUrl } = toRefs(state)

 
	const exit = function () {
		removeToken()
		router.push('/login')
	}


  const goto = function (url) {
		router.push(url)
	}


  const getMp3Url = () =>{
      let mp3Url = require("@/assets/audio/di.mp3") ; //require('@/assets/logo1.png'),
      return mp3Url
  }

  const audioElement = ref(null);
  const audioText = ref("开启声音");
  const playAudio = () => {
      if (audioElement.value) {
        audioText.value = "已开启声音"
        audioElement.value.play().catch(error => {
          console.error('播放失败:', error);
        });
      }
    };

</script>
 
<style >


    .icon {
      margin-top: 15px;
    }


  
    .el-dropdown-link {
      cursor: pointer;
      color: var(--el-color-primary);
      display: flex;
      align-items: center;
      outline: unset;
    }




  .header-box{

    width: 100%;


    .title {
      width: 100px;
      margin: -22px 0px 0 28px;
  
    }
  
  

    



    .header-box-top{

      display: flex;
      justify-content:flex-start;

      .hbt-item{

        height: 50px;
        font-size: 14px;
      
      }


      .payAudio{
        cursor: pointer; 
        color: #409eff;
      }
  


    }

    

    .tags-view{
      display: block;
      margin-top: 15px; 
      border-bottom: 1px solid #c9c6c6;
    }

  }


	
 
	
</style>